export function videoContainerRender() { return `<div class="video-container" id="video-container">

</div>` }